<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'Parameters',
  data() {
    return {
      startDateMenu: false,
      endDateMenu: false,
      item: {
        start_date: null,
        end_date: null,
      },
      modelName: 'AvailabilityOfTransmittersInTheWorkshop',
      firstDayOfWeek: 1,
    }
  },
  computed: {
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    locale() {
      return this.$i18n.locale === 'ch' ? 'zh' : this.$i18n.locale
    },
  },
  mounted() {
    this.firstDayOfWeek = this.unitsMeasurement.firstDayOfWeek
    let settingsFromStore = this.getSettingsFromStore()
    if (!settingsFromStore) {
      const endDate = moment(new Date()).format('YYYY-MM-DD')
      const startDate = moment(endDate, 'YYYY-MM-DD')
        .add(-1, 'month')
        .format('YYYY-MM-DD')
      this.item = {
        start_date: startDate,
        end_date: endDate,
      }
    } else {
      this.item = settingsFromStore
    }
    this.confirm()
  },
  methods: {
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.item),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
    confirm() {
      if (!this.item.start_date || !this.item.end_date) return
      this.setSettingsInStore()
      this.$emit('set-params', this.item)
    },
  },
}
</script>

<template>
  <v-container 
    fluid 
    grid-list-xs
  >
    <v-layout 
      row 
      wrap
    >
      <v-flex 
        md3 
        xs12
      >
        <div>
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            v-model="startDateMenu"
            :nudge-right="40"
            :return-value.sync="item.start_date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="item.start_date"
              :label="$t('label__start_date')"
              append-icon="event"
              readonly
            />
            <v-date-picker 
              v-model="item.start_date"
              :max="item.end_date"
              :first-day-of-week="firstDayOfWeek"
              :locale="locale"
              @input="$refs.startDateMenu.save(item.start_date)"
            />
          </v-menu>
        </div>
      </v-flex>
      <v-flex 
        md3 
        xs12
      >
        <div>
          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            v-model="endDateMenu"
            :nudge-right="40"
            :return-value.sync="item.end_date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="item.end_date"
              :label="$t('label__end_date')"
              append-icon="event"
              readonly
            />
            <v-date-picker 
              v-model="item.end_date"
              :min="item.start_date"
              :first-day-of-week="firstDayOfWeek"
              :locale="locale"
              @input="$refs.endDateMenu.save(item.end_date)"
            />
          </v-menu>
        </div>
      </v-flex>
    </v-layout>
    <v-flex
      md2
      xs12
    >
      <v-btn
        color="primary"
        block
        @click="confirm()"
      >
        {{ $t('buttons__apply') }}
      </v-btn>
    </v-flex>
  </v-container>
</template>
